import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import CoursesApi from '../../apis/CoursesApi';
import LoadingCircle from '../../components/LoadingCircle/LoadingCircle';
import UnexpectedError from '../../components/UnexpectedError/UnexpectedError';
import useApi from '../../lib/useApi';
import useFooterControl from '../../lib/useFooterControl';
import ArticlesSection from './sections/ArticlesSection';
import CourseSection, { CoursePreview } from './sections/CourseSection';
import PersonalSection, { CourseProgress } from './sections/PersonalSection';

/**
 * The main training view for the user
 */
const TrainingView = () => {
  const theme = useTheme();
  const isMediumOrBigger = useMediaQuery(theme.breakpoints.up('md'));
  const coursesApi = useApi(CoursesApi);
  const [isLoading, setIsLoading] = useState(true);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [courses, setCourses] = useState<CoursePreview[]>([]);
  const [courseProgress, setCourseProgress] = useState<CourseProgress[]>([]);
  useFooterControl(false);

  useEffect(() => {
    coursesApi
      .GetTrainingPageCourseDetails()
      .then((t) => {
        setCourses(t as unknown as CoursePreview[]);
        setCourseProgress(t as unknown as CourseProgress[]);
      })
      .catch(() => {
        setErrorOccurred(true);
      })
      .finally(() => setIsLoading(false));
  }, [coursesApi]);

  return (
    <Box height="100%" width="100%" padding="1em">
      {errorOccurred ? (
        <UnexpectedError errorContext="the training page" />
      ) : (
        <>
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <CourseSection coursePreviews={courses} />
              {isMediumOrBigger ? (
                <ArticlesSection />
              ) : (
                <PersonalSection courseProgress={courseProgress} />
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              {isMediumOrBigger ? (
                <PersonalSection courseProgress={courseProgress} />
              ) : (
                <ArticlesSection />
              )}
            </Grid>
          </Grid>
          <LoadingCircle isLoading={isLoading} />
        </>
      )}
    </Box>
  );
};

export default TrainingView;
